import styled, { css } from 'styled-components';
import { CloseIcon as Icon } from '@sainsburys-tech/bolt-icons';
import { themeContract } from './tooltip.theme';
var Wrapper = styled.div.withConfig({
  displayName: "Tooltipstyles__Wrapper",
  componentId: "z8evsy-0"
})(["position:relative;"]);
var Body = styled.div.withConfig({
  displayName: "Tooltipstyles__Body",
  componentId: "z8evsy-1"
})(["flex:0 1 100%;display:flex;align-items:center;justify-content:center;"]);
var Content = styled.div.withConfig({
  displayName: "Tooltipstyles__Content",
  componentId: "z8evsy-2"
})(["padding:10px 12px;display:flex;", ""], function (props) {
  return css(["width:", "px;"], props.width);
});
var Close = styled.button.withConfig({
  displayName: "Tooltipstyles__Close",
  componentId: "z8evsy-3"
})(["padding:5px;border:none;background:transparent;z-index:1;height:30px;"]);
var CloseIcon = styled(Icon).withConfig({
  displayName: "Tooltipstyles__CloseIcon",
  componentId: "z8evsy-4"
})(["cursor:pointer;fill:", ";"], function (props) {
  return props.theme.color.monochrome.base;
});
var Arrow = styled.div.withConfig({
  displayName: "Tooltipstyles__Arrow",
  componentId: "z8evsy-5"
})(["position:absolute;&::before,&::after{content:'';position:absolute;bottom:100%;left:50%;width:0;height:0;}&::before{margin-left:-11px;border-bottom:11px solid ", ";border-right:11px solid transparent;border-left:11px solid transparent;}&::after{margin-left:-9px;border-bottom:9px solid ", ";border-right:9px solid transparent;border-left:9px solid transparent;}", " ", " ", " ", ""], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.direction === 'up' && css(["bottom:auto;top:100%;transform:rotateX(180deg);"]);
}, function (props) {
  return props.direction === 'left' && css(["right:0;top:50%;transform:rotate(90deg);"]);
}, function (props) {
  return props.direction === 'right' && css(["left:0;top:50%;transform:rotate(270deg);"]);
}, function (props) {
  return ['success', 'info', 'error'].includes(props.kind) && css(["::before{border-bottom-color:", ";}::after{border-bottom-color:", ";}"], themeContract[props.theme.channel][props.kind].border, themeContract[props.theme.channel][props.kind].background);
});
var Bubble = styled.div.withConfig({
  displayName: "Tooltipstyles__Bubble",
  componentId: "z8evsy-6"
})(["background:", ";position:absolute;margin-top:10px;z-index:", ";border:1px solid ", ";border-radius:3px;box-shadow:0 0 6px 1px ", ";transition-property:visibility,opacity;transition-duration:200ms;transition-timing-function:ease;.ac-tooltip__wishlist{display:flex;text-align:left;p{padding:0 8px;line-height:normal;}}", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.modifier.layer['10'];
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.direction === 'upleft' && css(["bottom:100%;margin:0 0 10px;left:0;"]);
}, function (props) {
  return props.direction === 'upright' && css(["bottom:100%;margin:0 0 10px;right:0;"]);
}, function (props) {
  return props.direction === 'upcenter' && css(["bottom:100%;margin:0 0 10px;left:50%;transform:translateX(-50%);"]);
}, function (props) {
  return props.direction === 'downleft' && css(["left:0;"]);
}, function (props) {
  return props.direction === 'downright' && css(["right:0;"]);
}, function (props) {
  return props.direction === 'downcenter' && css(["left:50%;transform:translateX(-50%);"]);
}, function (props) {
  return (props.direction === 'leftcenter' || props.direction === 'leftright' || props.direction === 'leftleft') && css(["top:50%;margin:0;left:0;transform:translateX(-100%) translateX(-10px) translateY(-50%);"]);
}, function (props) {
  return (props.direction === 'rightcenter' || props.direction === 'rightright' || props.direction === 'rightleft') && css(["top:50%;margin:0;right:0;transform:translateX(100%) translateX(10px) translateY(-50%);"]);
}, function (props) {
  return ['success', 'info', 'error'].includes(props.kind) && css(["border:1px solid ", ";background:", ";"], themeContract[props.theme.channel][props.kind].border, themeContract[props.theme.channel][props.kind].background);
}, function (props) {
  return css(["visibility:", ";opacity:", ";"], props.visible ? 'visible' : 'hidden', props.visible ? 1 : 0);
});
export { Wrapper, Content, Body, Close, CloseIcon, Arrow, Bubble };